import { Control, Controller } from 'react-hook-form';

import { CurrencyTextInput } from '@/components/form-controls';
import { OverridableCalculatedValue } from '@/types/overridable-calculated-value';
import { formatCurrency } from '@/utils/formatting';

type AmpCellProps = {
  ndc: string
  amp?: OverridableCalculatedValue,
  isOverriding: boolean,
  control: Control<any>
};

export const AmpCell = ({ ndc, amp, isOverriding, control }: AmpCellProps) => {
  const formKey = `${ndc}.amp`;

  return (
    <div className="min-w-32">
      {isOverriding
        && <Controller
          control={control}
          name={formKey}
          render={({ field: { value, onChange, onBlur } }) => (
            <CurrencyTextInput
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              id={formKey}
              name={formKey}
            />
          )}
        />
      }

      {!isOverriding && amp?.overrideValue != null
        && <span>{formatCurrency(amp.overrideValue, 2, 2)}</span>
      }

      {!isOverriding && amp?.overrideValue == null && amp?.calculatedValue?.value != null
        && <span>{formatCurrency(amp.calculatedValue.value, 2, 2)}</span>
      }
    </div>
  );
};
